import { Cookies } from 'react-cookie';

export const cookies = new Cookies();

const getMainDomain = (domain) => domain.split('.').slice(-2).join('.');

export const setCookie = (name, value, domain) => (dispatch) =>
  cookies.set(name, value, { path: '/', sameSite: 'none', secure: true, domain: getMainDomain(domain) });

export const getCookie = (name) => (dispatch) => cookies.get(name);

export const removeCookie = (name, domain) => (dispatch) => cookies.remove(name, { path: '/', domain: getMainDomain(domain) });
